import actionTypes from './actionTypes'
import config from '../../../config/config'
import { isSentry } from '../../../lib'

const {
  REQUEST_CHANGEPLAN,
  RECEIVE_CHANGEPLAN,
  REQUEST_STORAGEINFO,
  RECEIVE_STORAGEINFO,
  ERROR_CHANGEPLAN
} = actionTypes

export function changePlan (token, plan) {
  return function (dispatch) {
    dispatch({type: REQUEST_CHANGEPLAN})

    let plan_id
    if (plan === 'free') {
      plan_id = config.FREE
    } else if (plan === 'premium') {
      plan_id = config.PREMIUM
    }

    const payload = {
      new_plan_id: plan_id,
      new_plan_name: plan
    }

    return fetch(`${config.URI}/api/v1/stripe_update_subscription`, {
      method: 'put',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && (res.status === 'success')) {
          dispatch({type: RECEIVE_CHANGEPLAN})
        } else if (res.errors) {
          dispatch({type: ERROR_CHANGEPLAN})
          console.error(res.errors)
          return
        }
      })
      .catch(e => {
        console.error(e)
        isSentry(e)
      })
  }
}

export function getStorageInfo (token) {
  return function (dispatch) {
    dispatch({type: REQUEST_STORAGEINFO})
    return fetch(`${config.URI}/api/v1/storage_info`, {
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && (res.status === 'success')) {
          dispatch({type: RECEIVE_STORAGEINFO, storageInfo: res.data.storage_info_kb})
        } else if (res.errors) {
          dispatch({type: RECEIVE_STORAGEINFO, storageInfo: ''})
          console.error(res.errors)
        }
      })
      .catch(e => {
        console.error(e)
        isSentry(e)
      })
  }
}



// WEBPACK FOOTER //
// ./src/routes/ManagePlans/actions/index.js